module.exports = __webpack_public_path__ + "static/media/logo.4083b4f7.png";